module.exports = __webpack_public_path__ + "img/144.f6e76185.jpg";